const s = "(max-width: 743px) and (hover: none) and (pointer: coarse)";
class a {
  constructor(t, e) {
    this.key = Symbol("match-media-key"), this.matches = !1, this.host = t, this.host.addController(this), this.media = window.matchMedia(e), this.matches = this.media.matches, this.onChange = this.onChange.bind(this), t.addController(this);
  }
  hostConnected() {
    var t;
    (t = this.media) == null || t.addEventListener("change", this.onChange);
  }
  hostDisconnected() {
    var t;
    (t = this.media) == null || t.removeEventListener("change", this.onChange);
  }
  onChange(t) {
    this.matches !== t.matches && (this.matches = t.matches, this.host.requestUpdate(this.key, !this.matches));
  }
}
export {
  s as I,
  a as M
};
//# sourceMappingURL=MatchMedia-D1Uy-Fr0.js.map
